<div class="password-container">
  <div class="password-box">
    <div class="mb-4">
      <img src="assets/logos/iris.colored.svg" alt="Iris Watch" width="70" />
    </div>

    <div>
      <form [formGroup]="passwordForm" (submit)="setPassword()">
        <h1 class="tw-text-lg tw-font-semibold mb-1">Get started</h1>
        <p class="tw-text-sm tw-text-gray-500 mb-4">Set password for your account!</p>

        <label>Email Address</label>
        <input
          required
          type="email"
          class="form-control"
          placeholder="name@example.com"
          formControlName="email"
          [disabled]="true"
        />

        <label>New Password</label>
        <input
          type="password"
          formControlName="password"
          class="form-control"
          placeholder="Password"
          required
        />

        <label>Confirm Password</label>
        <input
          type="password"
          formControlName="confirmPassword"
          class="form-control"
          placeholder="Password"
          required
        />

        <button [disabled]="passwordForm.invalid" class="btn btn-primary full">
          Save Password
        </button>
      </form>
    </div>
  </div>
</div>
